import { useMutation } from "@apollo/client"
import { DELETE_TOURNAMENT_ORGANIZER } from "../queries/deleteTournamentOrganizer"

export const useDeleteTournamentOrganizer = () => {
  const [deleteOrganizer, { loading, error }] = useMutation(DELETE_TOURNAMENT_ORGANIZER)

  const deleteTournamentOrganizer = async (id: number) => {
    try {
      const { data } = await deleteOrganizer({
        variables: { id },
      })
      return data?.deleteTournamentOrganizer
    } catch (err) {
      console.error("Error deleting tournament organizer:", err)
      throw err
    }
  }

  return {
    deleteTournamentOrganizer,
    loading,
    error,
  }
}
